<template>
    <div class="layout" v-cloak style="min-height:100%;">
        <link rel="stylesheet" href="/static/css/layout.css" >
        <!-- 顶部黑边 header start -->
        <div class="header bg-white" style="box-shadow: 0px 0px 5px #888888;">
            <div class="center1200 temp-header">
                <router-link to="/index"><img src="/static/img/lighting_2.png" alt="" style="float:left;height:60px;"> </router-link>
                <!-- <div style="width:40px;display:inline-block;"></div> -->

                <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" style="width:320px;float:  left;margin-left:20px;">
                    <el-menu-item index="1" class=""><router-link to="/" class="block a">主页</router-link></el-menu-item>
                    <el-menu-item index="2" class=""><router-link to="/movies" class="block a">电影</router-link></el-menu-item>
                    <el-menu-item index="3" class="" >
                      <router-link to="/category" class="block a">
                          分类
                      </router-link>
                    </el-menu-item>
                    <el-menu-item index="4"><router-link to="/forum" class="block a">论坛</router-link></el-menu-item>
                  </el-menu>
                  <!-- <div class="line"></div> -->

                  <form @keyup.enter="search()">
                  <el-input placeholder="请输入内容" v-model="input_search" class="input-with-select" style="float:left;width:400px;margin-top:12px;">
                    <el-select v-model="select_search" slot="prepend" placeholder="请选择" style="width:100px;" >
                      <el-option label="电影" value="电影"></el-option>
                      <el-option label="分类" value="分类"></el-option>
                      <el-option label="用户" value="用户"></el-option>
                    </el-select>
                    <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
                  </el-input>
                </form>

                <div style="float:  right;margin-top:10px;">

                    <router-link to="/login" v-if="!token"><el-button size="small" >登录</el-button></router-link>
                    <router-link to="/register" v-if="!token"><el-button size="small" >注册</el-button></router-link>
                    <!-- <el-button size="small" @click="logout()" v-if="token">登出</el-button> -->

                    <!-- <span v-if="username==''"></span>
                    <span v-else>{{username}}</span> -->
                    <a href="javascript:;" v-if="token"><img style="vertical-align: middle;margin-top:-30px;height:24px;" src="/static/img/lv/LV0.png" alt="" v-if="user_level==0"><img style="vertical-align: middle;margin-top:-30px;height:24px;" src="/static/img/lv/LV1.png" alt="" v-if="user_level==1"><img style="vertical-align: middle;margin-top:-30px;height:24px;" src="/static/img/lv/LV2.png" alt="" v-if="user_level==2"><img style="vertical-align: middle;margin-top:-30px;height:24px;" src="/static/img/lv/LV3.png" alt="" v-if="user_level==3"><img style="vertical-align: middle;margin-top:-30px;height:24px;" src="/static/img/lv/LV4.png" alt="" v-if="user_level==4"><img style="vertical-align: middle;margin-top:-30px;height:24px;" src="/static/img/lv/LV5.png" alt="" v-if="user_level==5"></a>
                    <a href="javascript:;" @click="goUserinfo" style="line-height:40px;font-weight: 500 !important;font-size:18px;text-decoration: none;color:#303133;font-family:'PingFang SC';max-width:180px;display: inline-block;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;text-align: right;">{{username}}</a>
                    <el-dropdown v-if="token">
                        <span class="el-dropdown-link">
                          <a href="javascript:;" @click="goUserinfo" >
                                <img :src="user_pic" alt="" class="head" style="margin-top:-32px;">
                          </a>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item><a href="javascript:;" @click="goUserinfo" class="block">个人主页</a></el-dropdown-item>
                          <el-dropdown-item><router-link to="/account" class="block">账号管理</router-link></el-dropdown-item>
                          <el-dropdown-item divided><span @click="logout()" class="block">退出登录</span></el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      

                </div>
            </div>
        </div>
        <!-- 顶部黑边 header end -->
        <!-- 正文替换部分 start -->
        <div style="min-height:81%;">
            
            <keep-alive>
                <router-view style="height:100%;"></router-view>
            </keep-alive>
        </div>
        <!-- 正文替换部分 end -->
        <!-- footer start -->
        <div class="footer">
            <div class="center1200" style="text-align:center;">
                <p>
                    <router-link to="/aboutus">关于我们</router-link>
                    <a href="/admin/weather">进入后台</a>
                    <router-link to="/feedback">用户反馈</router-link>
                    <br>
                    <div class="h10"></div>
                    Copyright©2023 All Rights Reserved. Lighting版权所有 & 苏ICP备20021560号







                </p>
            </div>
        </div>
        <!-- footer end -->
    </div>
</template>

<script>
    export default {
      data() {
        return {
          activeIndex: '1',
          // activeIndex2: '1',
          //搜索的关键字
          input_search:'',
          //选中的搜索条件
          select_search:"电影",

          //用户的id
          token:'',
          //用户名
          username:'',
          //用户图片
          user_pic:'/static/img/default_userpic.png',
          //用户等级
          user_level:0,
        };
      },
      methods: {
        //顶部菜单点击触发
        handleSelect(key, keyPath) {
          
          
        },
        //登出
        logout(){
          localStorage.removeItem("token");
          this.$message({
            showClose:true,
            message:'登出成功 :)',
            type:'success'
          })
          this.$router.push('/login');
        },

        //搜索按钮点击
        search(){
          //获取选中的搜索条件
          
          var select = this.select_search
          //获取keyword
          
          var keyword = this.input_search
          if(!(select && keyword)){
            this.$message({
              showClose:true,
              message:'完善搜索条件',
              type:"error",
              offset:80,
              duration:1000,
            })
            return false;
          }
          // 电影的搜索
          if(select == "电影"){
            this.$router.push('/searchmovie/'+keyword).catch(err=>{err});
          }

          if(select == "分类"){
            this.$router.push('/categorydetail/'+keyword).catch(err => {err});
          }

          if(select == "用户"){
            this.$router.push('/searchuser/'+keyword).catch(err=>{err});
          }
          

        },
      
        //根据用户id去他的主页（这里由于是用户自己才能点到的位置，所有id的获取采用getLocalStorage
        goUserinfo(){
          this.$router.push('/user/'+this.token).catch(err => {err});
        },
        
        //获取当前登录的用户信息
        getUserinfo(){
          if(localStorage.getItem('token')==null){
            return false;
          }
            $.ajax({
              url:'//'+ this.$API_URL +'/api/v1/user_info/'+this.token,
              type:'get',
              timeout:3000,
              success:(ret)=>{
                  this.user_level = ret.data.level
                  if(ret.data.nickname){
                    this.username = ret.data.nickname
                  }
                  else{
                    //否则显示用户的手机号
                    this.username = ret.data.mobile
                  }
                  if(ret.data.user_pic == "http://"+ this.$API_URL){
                    this.user_pic = '/static/img/default_userpic.png'
                  }else{
                    this.user_pic = ret.data.user_pic
                  }
                  // this.getusername = ret.data.username
                  // /users/user_pics/2020_06_06/036fe7d42aea375b56eaee70c153c6d4.png
                  
              }
          })

        },
        //返回
        goback(){
            this.$router.go(-1);
        },
        // 回到顶部
        gotop(){
            const that = this
            let timer = setInterval(() => {
                let ispeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                if (that.scrollTop === 0) {
                clearInterval(timer)
                }
            }, 16)
  
        },
      },

      mounted(){
        this.token = localStorage.getItem('token');
        

        this.getUserinfo();
      
      },

    }
  </script>
<style scoped>

/* .el-select .el-input {
  } */
    .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
.a{
  width:100%;
  height:100%;
  display: block;
}
.block{
  text-decoration: none;
  display: block;
  width:100%;
  height:100%;
  color:#909399
}
.block:hover{
  color:#ff7400;
}
.el-menu-item {
  padding:0;
  width:70px;
  text-align: center;
  /* margin:0 20px; */
}
</style>



// WEBPACK FOOTER //
// src/components/index/layout.vue